import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useApp } from "../context/AppContext";
import PageTransition from "../components/PageTransition";
import { SHA256 } from "crypto-js";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { loading, setLoading } = useApp();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      setLoading(true);
      // Хешируем пароль на клиенте
      const hashedPassword = SHA256(formData.password).toString();
      await login(formData.username, hashedPassword);
      navigate("/");
    } catch (error) {
      console.error("Error logging in:", error);
      setError("Неверное имя пользователя или пароль");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageTransition>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "grey.100",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: "100%",
            maxWidth: 400,
          }}
        >
          <Typography variant="h4" align="center" gutterBottom>
            Вход в систему
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Имя пользователя"
              margin="normal"
              value={formData.username}
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
              error={!!error}
              disabled={loading}
              autoComplete="username"
            />

            <TextField
              fullWidth
              label="Пароль"
              type="password"
              margin="normal"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              error={!!error}
              disabled={loading}
              autoComplete="current-password"
            />

            {error && (
              <Typography color="error" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}

            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              sx={{ mt: 3 }}
            >
              {loading ? <CircularProgress size={24} /> : "Войти"}
            </Button>
          </form>
        </Paper>
      </Box>
    </PageTransition>
  );
};

export default Login;
